<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>Is payment taxable?<Caret /></summary>
  <p>
    For most individuals, the compensation itself is tax-free.
  </p>
  <p>
    JLG does not offer personal tax advice. Please contact a tax professional for advice on this matter.
  </p>
</details>
